import basePath from "base_path";

import ActionTypes, {MattersActionTypes} from "../constants/action_types";
import createReduxPromiseAction from "utils/create_redux_promise_action";
import {OrganisationId} from "common/types/organisation";
import {ProjectId} from "common/types/project";
import {
  CollectionTypeNames,
  FileItem,
  Matter,
  MatterId,
} from "common/types/matter";

export type MatterAddDocumentsAction = {
  type: MattersActionTypes["MATTER_ADD_DOCUMENTS"]["SUCCESS"];
  payload: Matter;
};

export default function addDocumentsToMatter(requestor) {
  return createReduxPromiseAction(
    ActionTypes.MATTER_ADD_DOCUMENTS,
    (
      organisationId: OrganisationId,
      projectId: ProjectId,
      matterId: MatterId,
      fileItems: FileItem[],
      collectionTypeNames: CollectionTypeNames,
      targetParentDocumentId?: number,
      removedMsaIds: number[] = [],
      issuesetId?: number | null,
    ) => {
      const formData = new FormData();

      const metadata = fileItems.map((item, index) => {
        const fileField = `file_${index}`;
        formData.append(fileField, item.file);

        return {
          fileField,
          documentType: item.documentType,
          documentGroup: item.documentGroup,
        };
      });

      formData.append("fileItems", JSON.stringify(metadata));

      formData.append(
        "collectionTypeNames",
        JSON.stringify(collectionTypeNames),
      );

      if (targetParentDocumentId !== undefined) {
        formData.append(
          "targetParentDocumentId",
          String(targetParentDocumentId),
        );
      }

      if (removedMsaIds.length > 0) {
        formData.append("removedMsaIds", JSON.stringify(removedMsaIds));
      }

      if (issuesetId) {
        formData.append("issuesetId", String(issuesetId));
      }

      return requestor
        .post(
          `${basePath}/organisation/${organisationId}/project/${projectId}/matter/${matterId}/documents`,
          formData,
          {
            withCredentials: true,
          },
        )
        .then(response => {
          return response.data;
        });
    },
  );
}
